const ContactUsSideInput = ({title,placeHolder,name,onChange,value,onBlur,onInput,maxLength}) => {
    return(
        <div >
            <p className="text-[18px] font-IRANYekanBold text-mainColor2 mb-[6px]">{title}</p>
            <input 
            name={name} onChange={onChange}value={value}  onBlur={onBlur} onInput={onInput} maxLength={maxLength}
            className="h-[38px]   w-full focus:outline-lightGray border-[2px] border-borderGray text-[13px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" placeholder={placeHolder} />
        </div>
    )
}

export default ContactUsSideInput;